import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function QuoteSuccessPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // 🔥 Google Ads Conversion (σωστό σημείο)
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-17953980284/G3tjCOT-1_gbEPz-j_FC'
      });
    }
  }, []);

  return (
    <div className="paper-texture-bg min-h-screen flex items-center justify-center px-6">
      
      <div className="max-w-md w-full text-center">
        
        {/* Icon */}
        <div className="w-20 h-20 bg-[#C6A87A] rounded-2xl flex items-center justify-center mx-auto mb-8 shadow-lg shadow-[#C6A87A]/20">
          ✓
        </div>

        {/* Title */}
        <h1 className="text-3xl md:text-4xl font-bold mb-4 text-[#1a1410]">
          Request Submitted!
        </h1>

        {/* Text */}
        <p className="text-[#4A3F35] mb-3 text-base leading-relaxed">
          Thank you for your quote request. Our team will review it and We�ll contact you shortly (usually within 30 minutes).
        </p>

        <p className="text-sm text-[#4A3F35]/60 mb-10">
          Confirmation sent to your email
        </p>

        {/* Button */}
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center justify-center gap-2 bg-[#1a1410] hover:bg-[#332a24] text-[#F5F3ED] px-8 py-4 text-sm font-medium transition-all duration-300 rounded-sm"
        >
          ← Back to Home
        </button>

      </div>
    </div>
  );
}